import React, {Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {store} from './app/store';
import {Provider} from 'react-redux'
import SuspenseContent from './containers/SuspenseContent';
import { initializeAuthListener } from './features/auth/authSlice';
import { BrowserRouter as Router, Navigate, Route, Routes, useNavigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './app/queryClient';
import lazyWithReload from './utils/lazyWithReload';
import AppErrorBoundary from './containers/AppErrorBoundary';

const Layout = lazyWithReload(() => import('./containers/Layout'))
const Login = lazyWithReload(() => import('./pages/Login'))
const ForgotPassword = lazyWithReload(() => import('./pages/ForgotPassword'))

const root = ReactDOM.createRoot(document.getElementById('root'));

store.dispatch(initializeAuthListener());

root.render(
  // <React.StrictMode>
  <AppErrorBoundary>
    <Suspense fallback={<SuspenseContent />}>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <Router>
            <Routes>
              <Route path="/" element={<App />}>
                <Route path="login" element={<Login />} />
                <Route path="forgot-password" element={<ForgotPassword />} />
                <Route path="app/*" element={<Layout />} />
                <Route path="*" element={<Navigate to="login" replace={true} />} />
              </Route>
            </Routes>
          </Router>
        </QueryClientProvider>
        <Toaster position="top-center" />
      </Provider>
    </Suspense>
  </AppErrorBoundary>
  // </React.StrictMode>
);
